<template>
  <div>
    <div v-if="!signConfiguration.firma">
      <div v-if="ambit === ambits.profile">
        <h3>¿Con que no tienes firma digital?</h3>
        Para comenzar a operar con <b>Firma Simple</b>, primero debemos crearte una <b>Firma
        Digital</b>, es como tu
        firma en papel, pero ahora será electrónica,
        y mucho más segura. Antes de poder generarte el certificado digital, primero debemos
        asegurarnos que tu perfil se
        encuentra configurado correctamente,
        para ello es necesario que revises si ya se ha configurado tu <b>cargo</b> actual asi como
        la
        <b>gerencia o departamento</b> al que
        perteneces, ya que tu firma incluirá dicha información.
        <br/><br/>
        <p>
          Además de que tus datos esten correctamente configurados,
          necesitaremos que configures <b>2FA</b>,
          para dar mayor
          seguridad al proceso.
        </p>
        <br/><br/>
        Junto con esto, comunicate con tu administrador de sistema para que te habilite tu
        firma
      </div>
      <div v-else>
        <ActiveSign
          :configurations="signConfiguration"
          :user="signConfiguration.usuario"
          @activate="activate"
        />
      </div>
    </div>
    <div v-if="signConfiguration.firma">
      <h4>Configuración de firma <b>Activa</b></h4>
<!--      TODO: completar configurador de firma-->
<!--      <sign-configuration-->
<!--        :sign="signConfiguration"-->
<!--        :user="signConfiguration.usuario"-->
<!--      ></sign-configuration>-->
      <img :src="signConfiguration.estampa" width="300px" style="border: dashed 1px black;">
      <div class="divider"></div>
      <div v-if="ambit === ambits.profile">
        <br>
        <div class="row" v-if="showPdf">
          <div class="col-12 col-md-6 container-pdf">
            <pdf
              :src="url"
              v-for="i in numPages"
              :key="i"
              :page="i"
            />
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12 form-group">
                <label for="otp">Código OTP</label>
                <input
                  v-validate="'numeric|required|min:4|max:6'"
                  name="otp"
                  id="otp"
                  maxlength="6"
                  class="form-control"
                  placeholder="OTP"
                  size="small"
                  v-model="otp"
                />
                <small id="otpHelp" class="form-text text-muted">
                  * Son los seis números que te muestra el Google Authenticator.
                </small>
                <small id="otpError" class="form-text text-danger" v-if="errors.has('otp')">
                  *{{ errors.first('otp') }}
                </small>
              </div>
            </div>
            <div class="row" v-if="sendingSign">
              <b-spinner
                small
                variant="primary"
              />
            </div>
            <div class="row mb-2" v-if="!sendingSign">
              <div class="col-12">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkConfirmationRead"
                    v-model="confirmationRead"
                  >
                  <label class="custom-control-label" for="checkConfirmationRead">
                    HE LEÍDO Y ACEPTO LAS CONDICIONES
                  </label>
                </div>
              </div>
            </div>
            <div class="row justify-content-end text-right" v-if="!sendingSign">
              <!--              <div class="col-md-5">-->
              <!--                <button-->
              <!--                  class="btn btn-info "-->
              <!--                  type="button"-->
              <!--                  @click="changeToConfig"-->
              <!--                >-->
              <!--                  Volver a Configuración-->
              <!--                </button>-->
              <!--              </div>-->
              <div class="col-md-7">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="signAndConfigure"
                  :disabled="!confirmationRead"
                >
                  Confirmar responsabilidad.
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row d-flex justify-content-end text-right"
          v-if="signConfiguration.firma.activa=== certStatus.CREATE"
        >
          <div class="col-md-6" v-if="showConfig">
            <button
              class="btn btn-primary"
              type="button"
              @click="changeToPdf"
            >
              Leer responsabilidad
            </button>
          </div>
        </div>
        <div
          class="row row justify-content-end text-right"
          v-if="signConfiguration.firma.activa=== certStatus.ACTIVE"
        >
          <div class="col align-self-end">
            <button
              class="btn btn-primary"
              type="button"
              @click="saveConfiguration"
              v-if="!savingConfig"
            >
              Guardar configuracion
            </button>
            <b-spinner
              small
              v-if="savingConfig"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf-signature';
import { mapGetters } from 'vuex';

import { configureSimpleAndEsign7Sign } from '@/febos/servicios/api/usuarios.api';
import { findValue } from '@/febos/global/utils/configurations';
import ActiveSign from '@/febos/global/usuario/components/sign/simple/agile/ActiveSign';
import {
  ambits,
  certStatus,
  configType,
  configutationsIds,
  proveedor
} from '@/febos/global/usuario/components/sign/simple/agile/constants';
import {
  ioGetPrivateUploadUrl,
  ioSaveConfigurations,
  ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';
import { base64ToBlob } from '@/febos/global/utils/files';
// import SignConfiguration
// from '@/febos/global/usuario/components/sign/simple/agile/SignConfiguration';

export default {
  name: 'SimpleSignSAgile',
  components: {
    // SignConfiguration,
    ActiveSign,
    pdf
  },
  data() {
    return {
      showConfig: true,
      showPdf: false,
      confirmationRead: false,
      savingConfig: false,
      sendingSign: false,
      numPages: undefined,
      otp: '',
      certStatus,
      ambits,
      configurations: {
        templateType: '1',
        textTemplate: '',
        background: undefined,
        emulation: '',
        respresentation: '',
      },
      progress: {
        enabled: false,
        percent: 0,
        indeterminate: true
      },
      url: '',
      firma: {}
    };
  },
  mounted() {
    this.firma = this.signConfiguration && this.signConfiguration.firma;
    this.url = this.signConfiguration.urlResponsavilidad;
    if (this.url) {
      this.loadPdfFile();
      this.showPdf = true;
      this.showConfig = false;
    }
    this.loadConfigurationParts();
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    getConfigurationValue(config) {
      return findValue(this.signConfiguration[config]);
    },
    createParameter(value, id) {
      if (value) {
        return { valor: value, parametroId: id };
      }
      return null;
    },
    loadConfigurationParts() {
      const [, typeValue] = this.getConfigurationValue(configutationsIds.type);
      const [, templateValue] = this.getConfigurationValue(configutationsIds.template);
      const [, backGroundValue] = this.getConfigurationValue(configutationsIds.background);
      const [, emulationValue] = this.getConfigurationValue(configutationsIds.emulation);
      const [, respresentationValue] = this.getConfigurationValue(
        configutationsIds.respresentation
      );
      this.configurations.templateType = typeValue || 1;
      this.configurations.textTemplate = templateValue;
      this.configurations.background = backGroundValue;
      this.configurations.emulation = emulationValue;
      this.configurations.respresentation = respresentationValue;
    },
    async uploadImageDataToS3(data) {
      if (data && data.startsWith('data:image')) {
        this.progress.enabled = true;
        this.progress.indeterminate = true;
        const fileMime = 'image/png';
        const base64ImageContent = data.replace(/^data:image\/(png|jpg);base64,/, '');
        const fileData = base64ToBlob(base64ImageContent, fileMime, 'signature.png');
        const ahora = new Date().getTime();
        const basePublicUrl = 'febos-io/publicar';
        const url = '/archivos.febos.io/'
          + `${process.env.VUE_APP_CODIGO_PAIS_S3}/${process.env.VUE_APP_AMBIENTE}/`
          + `usuario/${this.user.iut}/firma/${ahora}.png`;
        const response = await ioGetPrivateUploadUrl(`${basePublicUrl}${url}`, fileMime);
        this.progress.indeterminate = false;
        await ioUploadFileToPrivateUrl(
          response.data?.url,
          fileData,
          (percent) => {
            this.progress.percent = percent;
          }
        );
        return url;
      }
      return null;
    },
    async getConfigurationToSave() {
      const configurations = [];
      let configuration = this.createParameter(
        this.configurations.templateType, configutationsIds.type
      );
      if (configuration) {
        configurations.push(configuration);
      }
      configuration = this.createParameter(
        this.configurations.textTemplate, configutationsIds.template
      );
      if (configuration) {
        configurations.push(configuration);
      }
      switch (this.configurations.templateType) {
        case configType.desing: {
          configuration = this.createParameter(
            this.configurations.emulation, configutationsIds.emulation
          );
          if (configuration) {
            configurations.push(configuration);
          }
          break;
        }
        case configType.atached:
        case configType.draw: {
          const data = await this.uploadImageDataToS3(this.configurations.respresentation);
          configuration = this.createParameter(
            data, configutationsIds.respresentation
          );
          if (configuration) {
            configurations.push(configuration);
          }
          break;
        }
        default: {
          break;
        }
      }
      return configurations;
    },
    async saveConfiguration() {
      try {
        this.savingConfig = true;
        const configutarions = await this.getConfigurationToSave();
        await ioSaveConfigurations(
          {
            origen: 'USUARIO'
          },
          configutarions
        );
        this.$bvToast.toast(
          'Configuraciones Guardadas',
          {
            title: 'Firma',
            variant: 'info',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } finally {
        this.savingConfig = false;
      }
    },
    async signAndConfigure() {
      if (!this.otp.trim() || this.errors.has('otp')) {
        return;
      }
      try {
        this.sendingSign = true;
        const data = {
          categoria: 'ACTIVAR_U',
          codigo: this.otp,
          idUsuarioFirma: this.user.id,
          parametros: { archivoFirmar: this.url },
          proveedor,
          tipoFirma: 'firmaSimple'
        };
        await configureSimpleAndEsign7Sign(data);
        this.$bvToast.toast(
          'Certificado Activado',
          {
            title: 'Firma',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.$emit('activate', {});
      } finally {
        this.sendingSign = false;
      }
    },
    activate() {
      this.$emit('activate', {});
    },
    changeToPdf() {
      this.showPdf = true;
      this.showConfig = false;
    },
    changeToConfig() {
      this.showPdf = false;
      this.showConfig = true;
    },
    loadPdfFile() {
      const selectedFile = pdf.createLoadingTask(this.url);
      selectedFile.promise.then((pdfUrl) => {
        this.numPages = pdfUrl.numPages;
      });
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    signConfiguration: {
      type: Object,
      required: true
    },
    ambit: {
      type: String,
      required: true,
      default: 'perfil'
    }
  }
};
</script>
<style>
.container-pdf {
  max-height: 80vh;
  overflow-y: auto;
  position: relative;

}
</style>
